import React from 'react';
import PropTypes from 'prop-types';
import cn from "classnames"
import injectSheet from 'react-jss';

function Heading(props) {
    const { classes, className, children, tag: Tag, dataCy } = props;
    return <Tag className={cn( classes.header, className )} data-cy={dataCy}>{children}</Tag>;
}

Heading.propTypes = {
    tag: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};

Heading.defaultProps = {
    tag: "h1"
};

export default injectSheet(
    {
        // Styles are taken care of using the globals
    }
)(Heading);



// WEBPACK FOOTER //
// ./src/components/Widgets/Heading.js